<template>
  <div>
    <h5 class="mb-3">
      Enter the desired amount of MEDPadala credit to be used
    </h5>
    <b-form-group
      label="Amount"
      :class="{ 'mb-5': !isAmountGreaterThanBalance }"
    >
      <b-form-input
        placeholder="Enter Amount"
        v-model="amount"
        id="amount"
        inputmode="numeric"
        @keydown.native="isNumber($event)"
        @keyup.native="formatCurrency"
        pattern="[0-9.]*"
        autocomplete="off"
      >
      </b-form-input>
      <b-form-text id="available-balance" class="mt-2"
        >Available Balance:
        <b
          class="text-primary"
          :style="{
            color:
              webDesign && webDesign.design
                ? `${webDesign.design.main_color} !important`
                : null
          }"
        >
          Php {{ medPadalaData.balance | twoDecimalPlaces }}
        </b>
      </b-form-text>
      <b-form-group>
        <b-form-text> {{ amountLessThanBalanceMessage }} </b-form-text>
      </b-form-group>
      <b-container id="transaction-amount-container">
        <div id="transaction-amount-label">Transaction Amount</div>
        <div id="transaction-amount">
          Php {{ cart.computed_total | twoDecimalPlaces }}
        </div>
      </b-container>
    </b-form-group>
    <b-form-group v-if="isAmountGreaterThanBalance" class="mb-5">
      <small class="text-dark"> {{ amountGreaterThanBalanceMessage }} </small>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col md="3" class="text-center text-md-left mb-3 mb-md-0">
          <b-button
            block
            pill
            class="
              text-uppercase
              min-width-0
              bg-transparent
              border-0
              text-muted
              mx-auto
              py-2
            "
            id="cancel"
            @click="cancelMedPadalaCredit"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col class="flex-shrink-0">
          <b-button
            variant="primary"
            class="text-uppercase border-0 py-2"
            block
            pill
            :disabled="isDisabledProceedButton || medPadalaLoading"
            :style="{
              backgroundColor:
                webDesign && webDesign.design && !isDisabledProceedButton
                  ? `${webDesign.design.main_color} !important`
                  : null,
              color:
                webDesign && webDesign.design && !isDisabledProceedButton
                  ? `${webDesign.design.button_text_color} !important`
                  : null
            }"
            id="proceed-to-checkout"
            @click="applyMedPadalaCredits"
          >
            Proceed to Checkout
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import { Decimal } from "decimal.js";

function transformCurrency(minFractionDigits, value) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: minFractionDigits ? 2 : null
  }).format((Math.floor(value * 100) / 100).toFixed(2));
}

export default {
  name: "UseMEDPadalaCredits",
  data() {
    return {
      amountLessThanBalanceMessage:
        "Please enter an amount not greater than your available MEDPadala credits.",
      amountGreaterThanBalanceMessage:
        "We are unable to accept your payment because the amount submitted exceeds the balance of your MEDPadala credits. Please adjust the amount accordingly."
    };
  },
  computed: {
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken
    }),
    ...mapGetters("medpadala", [
      "medPadalaData",
      "medPadalaErrors",
      "medPadalaLoading"
    ]),
    ...mapFields("medpadala", ["amount", "appliedCredits"]),
    ...mapFields("estore", ["cart"]),
    isDisabledProceedButton() {
      const amount = Number(this.amount ? this.amount.replace(/,/g, "") : 0);

      return (
        !amount ||
        amount > this.medPadalaData.balance ||
        amount > this.cart.computed_total
      );
    },
    isAmountGreaterThanBalance() {
      const amount = Number(this.amount ? this.amount.replace(/,/g, "") : 0);

      return amount > this.medPadalaData.balance;
    }
  },
  mounted() {
    this.amount = null;
  },
  filters: {
    twoDecimalPlaces: function(value = null) {
      if (value != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        var sNumber = Number(value.toString().match(re)[0]);
        let twoDecimalPlaces = new Decimal(sNumber);
        return Number(twoDecimalPlaces).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    }
  },
  methods: {
    ...mapActions({
      medPadalaSaveAmount: "estore/medPadalaSaveAmount"
    }),
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        (charCode >= 48 && charCode <= 57) ||
        charCode === 8 ||
        charCode === 110 ||
        charCode === 190
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    formatCurrency() {
      const amountField = document.getElementById("amount");
      const value = amountField.value.replace(/,/g, "");
      if (value.includes(".")) {
        amountField.value = `${transformCurrency(
          false,
          Number(value.split(".")[0])
        )}.${value
          .split(".")[1]
          .substring(0, 2)
          .replace(/-/g, "")}`;
      } else {
        amountField.value = transformCurrency(false, value).replace(/-/g, "");
      }
    },
    cancelMedPadalaCredit() {
      this.amount = null;
      this.$root.$emit("bv::hide::modal", "medpadala-modal");
    },
    async viewCart() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          customer_lat: this.coordinates.lat,
          customer_lng: this.coordinates.long
        }
      };

      await this.$store.dispatch("estore/viewCart", request);
    },
    async applyMedPadalaCredits() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          amount: this.amount
        }
      };
      await this.medPadalaSaveAmount(request).then(response => {
        if (this.medPadalaErrors === null) {
          this.appliedCredits = true;
          this.cart.computed_total = response.computed_total;
          this.$nextTick(() => {
            this.viewCart();
            this.$root.$emit("bv::hide::modal", "medpadala-modal");
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#available-balance {
  font-size: 16px;
}
.min-width-0 {
  min-width: initial;
}
#cancel {
  width: max-content;
}
#proceed-to-checkout:disabled {
  background-color: #d8dcde !important;
  color: #68737d !important;
}
#transaction-amount-container {
  margin-top: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #ffffff;
  box-shadow: 0px 0px 9.20904px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  #transaction-amount-label {
    font-size: 14px;
    font-weight: 400;
    color: #68737d;
    margin-bottom: 3px;
  }
  #transaction-amount {
    font-size: 16px;
    font-weight: 700;
  }
}
</style>
